import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { toast } from 'react-toastify'
import request from 'src/utils/request'

const initialState = {
  institutionData: {},
  minInstitutionData: {},
  error: '',
  status: 'idle', // idle | loading | succeeded | failed
  statusMin: 'idle', // idle | loading | succeeded | failed
}

export const getInstitution = createAsyncThunk(
  'institution/getInstitution',
  async (_, thunkAPI) => {
    const token = await thunkAPI.getState().auth.student.token
    const res = await request(token).get(`/students/institution`)
    const data = await res.data
    return data
  },
  {
    condition: (_, { getState }) => {
      const { status } = getState().institution
      return status === 'idle' // empêche double appel
    },
  },
)

export const getMinInstitutionInfo = createAsyncThunk(
  'institution/getMinInstitutionInfo',
  async () => {
    //const token = thunkAPI.getState().auth.teacher.token
    const res = await axios.get(`/students/min-institution-info`, {
      baseURL: `${process.env.REACT_APP_API_URL}`,
      headers: {
        'Access-Control-Allow-Origin': `${process.env.REACT_APP_API_URL}`,
        'Content-Type': 'application/json',
        //'Content-Type': 'multipart/form-data',
      },
    })
    const data = await res.data
    //console.log(data)
    return data
  },
  {
    condition: (_, { getState }) => {
      const { statusMin } = getState().institution
      return statusMin === 'idle' // empêche double appel
    },
  },
)

export const institutionSlice = createSlice({
  name: 'institution',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInstitution.pending, (state) => {
        return {
          ...state,
          status: 'loading',
        }
      })
      .addCase(getInstitution.fulfilled, (state, action) => {
        return {
          ...state,
          institutionData: action.payload[0],
          error: '',
          status: 'succeeded',
        }
      })
      .addCase(getInstitution.rejected, (state, action) => {
        return {
          ...state,
          error: action.error.message,
          status: 'failed',
        }
      })
      .addCase(getMinInstitutionInfo.pending, (state) => {
        return {
          ...state,
          statusMin: 'loading',
        }
      })
      .addCase(getMinInstitutionInfo.fulfilled, (state, action) => {
        return {
          ...state,
          minInstitutionData: action.payload[0],
          error: '',
          statusMin: 'succeeded',
        }
      })
      .addCase(getMinInstitutionInfo.rejected, (state, action) => {
        return {
          ...state,
          error: action.error.message,
          statusMin: 'failed',
        }
      })
  },
})

export default institutionSlice.reducer
